import { getNewRelicAgent } from './newRelic.mjs';

class LoggingProvider {
    static warn(message, error, additionalInfo) {
        this.addPageAction(message, "WARN", {
            ...(additionalInfo ?? {}),
            error,
        });
    }
    static info(message, additionalInfo) {
        this.addPageAction(message, "INFO", additionalInfo);
    }
    static error(message, error, additionalInfo) {
        const newRelicAgent = getNewRelicAgent();
        // So that we don't lose the detail of the error, make a copy of the error and insert the more friendly message into
        // the error. This will put both messages into the error string in New Relic
        let modifiedError = undefined;
        if (error) {
            modifiedError = structuredClone(error);
            modifiedError.message = `${message} - ${modifiedError.message}`;
        }
        if (newRelicAgent) {
            newRelicAgent?.noticeError(modifiedError ?? message, additionalInfo);
        }
        else {
            console.error(message, modifiedError, additionalInfo);
        }
    }
    static addPageAction(name, level, details) {
        const newRelicAgent = getNewRelicAgent();
        const fullDetails = {
            level,
            ...(details ?? {})
        };
        if (newRelicAgent) {
            newRelicAgent.addPageAction(name, fullDetails);
        }
        else {
            console.log(name, fullDetails);
        }
    }
}

export { LoggingProvider as default };
//# sourceMappingURL=loggingProvider.mjs.map
